import { http } from '../http';
import { userParmas } from '@/facilities/model/user';

export const userLogin = async (params: userParmas) => {
  const response = await http.post<userParmas>('/api/login', params);
  return response;
};

export const getOrganization = async () => {
  return await http.get('/api/organization');
};

export const putOrganSelected = async (id: string) => {
  return await http.put(`/api/organization/selected/${id}`);
};

export const getUserPermissions = async () => {
  return await http.get('/api/user/permissions');
};

export const getUserCurrentOrgan = async () => {
  return await http.get('/api/organization/selected');
};

export const logoutUser = async () => {
  return await http.put('/api/logout');
};

export const getLoginUserInfo = async () => {
  return await http.get('/api/user/info');
};
